import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import { ClbIconProps } from '@celebration/react/ClbIcon/ClbIcon.types';
import './icon.scss';

function Icon(props: Readonly<ClbIconProps>) {
    return <ClbIcon {...props} />;
}

export default Icon;
